'use client';
import MaterialLink from '@mui/material/Link';
import { styled } from '@mui/material/styles';
export const Link = styled(MaterialLink)(({ theme }) => ({
    color: theme.tokens.FuelColorTextLink,
    textDecorationColor: theme.tokens.FuelColorTextLink,
    '&:hover': {
        color: theme.tokens.FuelColorTextLinkHovered
    },
    '&.Mui-focusVisible': {
        boxShadow: theme.tokens.FuelShadowFocused,
        outline: 'none'
    }
}));
